// extracted by mini-css-extract-plugin
module.exports = {"subscriptionDetails":"SubscriptionDetails_subscriptionDetails__RfkfF"};